// extracted by mini-css-extract-plugin
export var borderRadius = "_6x-4";
export var large = "_6x-3";
export var logoContainer = "_6x-0";
export var nameLogo = "_6x-2";
export var small = "_6x-1";